
const accordionDefault = {
    init() {
        let accordionNodes = document.querySelectorAll('.c-accordion');

        if (! accordionNodes.length) {
            return;
        }
        let self = this;

        accordionNodes.forEach(accordionNode =>{
            self._responsiveBehaviour(accordionNode);
        });

    },

    toggleContent(button) {
        let accordionNode = button.parentElement;

        if (accordionNode.classList.contains('c-accordion--opened')) {
            accordionNode.querySelector('.c-accordion__content').style.height = '0px';
            accordionNode.classList.remove('c-accordion--opened')
        }
        else {
            accordionNode.querySelector('.c-accordion__content').style.height = accordionNode.dataset.contentHeight + 'px';
            accordionNode.classList.add('c-accordion--opened')
        }
    },

    _responsiveBehaviour(accordionNode) {
        accordionNode.dataset.contentHeight = accordionNode.querySelector('.c-accordion__content-inner').offsetHeight;
    }
};

window.accordionDefault = accordionDefault;

window.accordionDefault.init();

document.addEventListener('LokiRequestEnd', function () {
    window.accordionDefault.init();
});
